<template>
    <div>
      <v-snackbar
          :timeout="timeout"
          :top="y === 'top'"
          :bottom="y === 'bottom'"
          :right="x === 'right'"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :vertical="mode === 'vertical'"
          v-model="snackbar"
        >
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false"
            >{{$t('Close')}}</v-btn
          >
        </v-snackbar>
        <v-dialog  v-model="entgDialog" >
            <v-card color="grey lighten-5">
              <v-container class="pa-1 d-flex align-center justify-center" >
      <v-card elevation="4"  class="rounded-lg">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Fatura Entegrator Ayarları</v-toolbar-title>
            <v-spacer></v-spacer>
            {{ 'Fatura İşlemleri İçin Entegratör Ayarları Kayıt Edilmelidir. !!' }}
            <v-btn color="red darken-1" text @click="close()">Vazgeç</v-btn>
          </v-toolbar>
        
         
        </v-flex>

        <!-- Onay Dialogu -->
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title class="text-h5">Uyarı</v-card-title>
            <v-card-text>
              Eğer doldurmadan kapatırsanız fatura kesemezsiniz. Onaylıyor musunuz?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">Hayır</v-btn>
              <v-btn color="red darken-1" text @click="closeWizard">Evet</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Progress Bar -->
        <v-row class="px-6 pt-4">
          <v-stepper v-model="currentStep" flat>
            <v-stepper-header>
              <v-stepper-step :complete="currentStep > 1" :step="1">Entegratör</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 2" :step="2">Form Bilgileri</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 3" :step="3">XSLT Yükleme</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="currentStep > 4" :step="4">Özet</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- Adım 1: Entegratör Seçimi -->
              <v-stepper-content step="1">
                <v-row justify="center" class="px-6 py-4">
                  <v-col cols="12">
                    <h2 class="text-h5 font-weight-bold text-center mb-4" style="color: #4A90E2;">Entegratör Seçiniz</h2>
                    <v-row>
                      <v-col v-for="option in entegratorOptions" :key="option.name" cols="12">
                        <v-card
                          outlined
                          :class="{'selected-optionv2': entegrator.name === option.name}"
                          class="mb-3 d-flex align-center justify-start py-4 option-cardv2"
                          @click="entegrator = option"
                        >
                          <v-img
                            :src="option.image"
                            contain
                            class="mr-4"
                            max-width="50"
                          ></v-img>
                          <v-radio
                            :value="option.name"
                            v-model="entegrator"
                            class="d-none"
                          ></v-radio>
                          <span class="text-center font-weight-bold">{{ option.name }}</span>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center" class="px-6 pb-4" style="gap: 16px; justify-content: space-between;">
                  <v-col cols="5">
                    <v-btn color="secondary" block disabled rounded>GERİ</v-btn>
                  </v-col>
                  <v-col cols="5">
                    <v-btn 
                      color="primary" 
                      block 
                      :disabled="!entegrator" 
                      rounded 
                      @click="nextStep"
                    >İLERİ</v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <!-- Adım 2: Form Bilgileri -->
              <v-stepper-content step="2">
                <v-row justify="center" class="px-6 py-4">
                  <v-col cols="12">
                    <h2 class="text-h5 font-weight-bold text-center mb-4" style="color: #4A90E2;">Form Bilgileri</h2>
                    <v-divider class="my-4"></v-divider>
                    <h3 class="text-h6 font-weight-bold">E-Arşiv</h3>
                    <v-text-field label="Kullanıcı Adı" v-model="eArsiv.username" class="mt-3" outlined></v-text-field>
                    <v-text-field 
                      label="Şifre" 
                      :type="showEArsivPassword ? 'text' : 'password'" 
                      v-model="eArsiv.password" 
                      :append-icon="showEArsivPassword ? 'visibility' : 'visibility_off'" 
                      @click:append="toggleEArsivPassword"
                      class="mt-3"
                      outlined
                    ></v-text-field>
                    <v-divider class="my-4"></v-divider>
                    <h3 class="text-h6 font-weight-bold">E-Fatura</h3>
                    <v-text-field label="Kullanıcı Adı" v-model="eFatura.username" class="mt-3" outlined></v-text-field>
                    <v-text-field 
                      label="Şifre" 
                      :type="showEFaturaPassword ? 'text' : 'password'" 
                      v-model="eFatura.password" 
                      :append-icon="showEFaturaPassword ? 'visibility' : 'visibility_off'" 
                      @click:append="toggleEFaturaPassword"
                      class="mt-3"
                      outlined
                    ></v-text-field>
                    <v-col cols="12" v-if="entegrator.name === 'ELOGO'">
                      <v-divider class="my-4"></v-divider>
                      <h3 class="text-h6 font-weight-bold">Departman Bilgileri</h3>
                      <v-text-field label="Departman İsmi" v-model="departman" class="mt-3" outlined></v-text-field>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row justify="center" class="px-6 pb-4" style="gap: 16px; justify-content: space-between;">
                  <v-col cols="5">
                    <v-btn color="secondary" block rounded @click="prevStep">GERİ</v-btn>
                  </v-col>
                  <v-col cols="5">
                    <v-btn 
                      color="primary" 
                      block 
                      :disabled="!isFormValid" 
                      rounded 
                      @click="nextStep"
                    >İLERİ</v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>

              

              <!-- Adım 4: XSLT Yükleme -->
              <v-stepper-content step="3">
                <v-row justify="center" class="px-6 py-4">
                  <v-col cols="12">
                    <h2 class="text-h5 font-weight-bold text-center mb-4" style="color: #4A90E2;">XSLT Yükleme</h2>
                    <v-divider class="my-4"></v-divider>
                    <v-card-text>
                      <v-layout row wrap>
                        <div class="flex md12">
                          <!-- Açıklama Alanı -->
                          <v-text-field
                            label="Açıklama"
                            v-model="xsltDescription"
                            outlined
                            class="mb-4"
                          ></v-text-field>

                          <!-- E-Fatura Dosya Yükleme -->
                          <v-form ref="formEInvoice" enctype="multipart/form-data">
                            <input
                              hidden
                              type="file"
                              id="fileEInvoice"
                              ref="fileEInvoice"
                              @change="handleEInvoiceUpload"
                            />
                          </v-form>
                          <v-layout>
                            <v-text-field
                              label="XSLT Dosya Adı (E-Fatura)"
                              placeholder="Dosya seçiniz"
                              append-icon="attach_file"
                              @click:append="selectEInvoiceFile"
                              v-model="eInvoiceFileName"
                              outlined
                              class="mb-3"
                            ></v-text-field>
                          </v-layout>

                          <!-- E-Arşiv Dosya Yükleme -->
                          <v-form ref="formEArchive" enctype="multipart/form-data">
                            <input
                              hidden
                              type="file"
                              id="fileEArchive"
                              ref="fileEArchive"
                              @change="handleEArchiveUpload"
                            />
                          </v-form>
                          <v-layout>
                            <v-text-field
                              label="XSLT Dosya Adı (E-Arşiv)"
                              placeholder="Dosya seçiniz"
                              append-icon="attach_file"
                              @click:append="selectEArchiveFile"
                              v-model="eArchiveFileName"
                              outlined
                              class="mb-3"
                            ></v-text-field>
                          </v-layout>
                        </div>
                      </v-layout>
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row justify="center" class="px-6 pb-4" style="gap: 16px;">
                  <v-col cols="5">
                    <v-btn color="secondary" block rounded @click="prevStep">GERİ</v-btn>
                  </v-col>
                  <v-col cols="5">
                    <v-btn color="primary" block rounded @click="nextStep">İLERİ</v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <!-- Adım 3: Özet -->
              <v-stepper-content step="4">
                <v-row justify="center" class="px-6 py-4">
                  <v-col cols="12">
                    <h2 class="text-h5 font-weight-bold text-center mb-4" style="color: #4A90E2;">Özet</h2>
                    <v-divider class="my-4"></v-divider>
                    <p><strong>Seçilen Entegratör:</strong> {{ entegrator }}</p>
                    <p><strong>E-Arşiv Kullanıcı Adı:</strong> {{ eArsiv.username }}</p>
                    <p>
                      <strong>E-Arşiv Şifre:</strong> 
                      <span>{{ showEArsivPasswordSummary ? eArsiv.password : '********' }}</span>
                      <v-icon small @click="toggleEArsivPasswordSummary">
                        {{ showEArsivPasswordSummary ? 'mdi-eye' : 'mdi-eye-off' }}
                      </v-icon>
                    </p>
                    <p><strong>E-Fatura Kullanıcı Adı:</strong> {{ eFatura.username }}</p>
                    <p>
                      <strong>E-Fatura Şifre:</strong> 
                      <span>{{ showEFaturaPasswordSummary ? eFatura.password : '********' }}</span>
                      <v-icon small @click="toggleEFaturaPasswordSummary">
                        {{ showEFaturaPasswordSummary ? 'mdi-eye' : 'mdi-eye-off' }}
                      </v-icon>
                    </p>
                    <p v-if="entegrator.name === 'ELOGO'"><strong>Departman İsmi:</strong> {{ departman }}</p>
                  </v-col>
                </v-row>
                <v-row justify="center" class="px-6 pb-4" style="gap: 16px;">
                  <v-col cols="5">
                    <v-btn color="secondary" block rounded @click="prevStep">GERİ</v-btn>
                  </v-col>
                  <v-col cols="5">
                    <v-btn
                      color="primary"
                      block
                      rounded
                      :disabled="!isXsltValid"
                      @click="submitSettings"
                    >ONAYLA VE KAYDET</v-btn>
                  </v-col>
                </v-row>
               
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-row>
      </v-card>
    </v-container>

               
            </v-card>
       
     </v-dialog>
    </div>
   
    </template>
    <script>
    import tool from "../coper/tools";
    import auth from "../../../api/auth";
    export default {
     
      data () {
        return {
          mode: "",
          timeout: 6000,
          text1: null,
      snackbar: false,
      y: "top",
      x: "right",
            entgDialog: false,
            currentStep: 1,
      dialog: false,
      entegratorOptions: [
        { name: "UYUMSOFT", image: require('@/assets/images/uyumsoft2025.png'),url: "https://efatura.uyumsoft.com.tr/Services/Integration",
          entClassName: "Entegrator.UyumSoft.UyumSoftEFatura",
          bindingConfiguration: "BasicHttpBinding_IIntegration",entClassNameEArsiv:"Entegrator.UyumSoft.UyumSoftEArsiv",
          sqliteDB: "C:\Arkman\EFatura_UyumSoft.sqlite" },
        { name: "VERİBAN", image: require('@/assets/images/veriban2025.png'),  url: "http://efaturatransfer.veriban.com.tr/IntegrationService.svc",
          entClassName: "Entegrator.Veriban.VeribanEFatura",
          bindingConfiguration: "BasicHttpBinding_IIntegrationService1", entClassNameEArsiv:"Entegrator.Veriban.VeribanEArsiv",
          sqliteDB: "C:\Arkman\EFatura_Veriban.sqlite" },
        { name: "ELOGO", image: require('@/assets/images/elogo2025.png'), url: "https://pb.elogo.com.tr/PostBoxService.svc",
          entClassName: "Entegrator.Logo.LogoEFatura",
          bindingConfiguration: "PostBoxServiceEndpoint",entClassNameEArsiv:"Entegrator.Logo.LogoEArsiv",
          sqliteDB: "C:\Arkman\EFatura_Logo.sqlite",
          departmentRequired: true },
        { name: "EDM", image: require('@/assets/images/edm2025.png'), url: "https://portal2.edmbilisim.com.tr/EFaturaEDM/EFaturaEDM.svc",
          entClassName: "Entegrator.EDM.EDMEFatura",
          bindingConfiguration: "EFaturaEDMPort",
          sqliteDB: "C:\Arkman\EFatura_EDM.sqlite",entClassNameEArsiv:"Entegrator.EDM.EDMEArsiv" },
      ],
      entegrator: "",
      eArsiv: { username: "", password: "" },
      eFatura: { username: "", password: "" },
      departman: "",
      efaturaXslt: null,
      earsivXslt: null,
      eInvoiceFileName: "",
      eArchiveFileName: "",
      xsltDescription: "DEFAULT",
      showEArsivPassword: false,
      showEFaturaPassword: false,
      showEArsivPasswordSummary: false,
      showEFaturaPasswordSummary: false,
    };
        },
        computed: {
    isFormValid() {
      const basicValid =
        this.eArsiv.username &&
        this.eArsiv.password &&
        this.eFatura.username &&
        this.eFatura.password;

      return this.entegrator === "ELOGO"
        ? basicValid && this.departman
        : basicValid;
    },
    isXsltValid() {
      return this.eInvoiceFileName !== "" && this.eArchiveFileName !== "" && this.xsltDescription !== "";
    },
  },
      methods: {
        toggleEArsivPassword() {
      this.showEArsivPassword = !this.showEArsivPassword;
    },
    toggleEFaturaPassword() {
      this.showEFaturaPassword = !this.showEFaturaPassword;
    },
    toggleEArsivPasswordSummary() {
      this.showEArsivPasswordSummary = !this.showEArsivPasswordSummary;
    },
    toggleEFaturaPasswordSummary() {
      this.showEFaturaPasswordSummary = !this.showEFaturaPasswordSummary;
    },
    nextStep() {
      this.currentStep++;
    },
    prevStep() {
      this.currentStep--;
    },
    selectEInvoiceFile() {
      this.$refs.fileEInvoice.click();
    },
    handleEInvoiceUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.eInvoiceFileName = file.name;
      }
    },
    selectEArchiveFile() {
      this.$refs.fileEArchive.click();
    },
    handleEArchiveUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.eArchiveFileName = file.name;
      }
    },
     submitSettings() {
     
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
var dosyaInput={
  
  FaturaId:null,
  SirketKodu:credentials.SirketKodu,
  XsltAciklama:this.xsltDescription,
  XsltAd:this.eInvoiceFileName,
  XsltAd1:this.eArchiveFileName,
  XsltId:null,
  XsltId1:null
}





var params = dosyaInput;


this.$http
  .post(auth.API_URL + "api/TicketInvoice/InvoiceXsltTableSaveAuto", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader(),
    },
  })
  .then(
    (response) => {
      if (response.body.Status) {
       
        var entegratorAyar={
  EntClassName:this.entegrator.entClassName,
  BindingConfiguration:this.entegrator.bindingConfiguration,
  SQLiteDB:this.entegrator.sqliteDB,
  UserName:this.eFatura.username,
  Password:this.eFatura.password,
  Uri:this.entegrator.url,
  GibNoOlusturanTaraf:'ARKMAN'
};

var entegratorAyarEArsiv={
  EntClassName:this.entegrator.entClassNameEArsiv,
  BindingConfiguration:this.entegrator.bindingConfiguration,
  SQLiteDB:this.entegrator.sqliteDB,
  UserName:this.eArsiv.username,
  Password:this.eArsiv.password,
  Uri:this.entegrator.url,
  GibNoOlusturanTaraf:'ARKMAN'
};

      var prm = {
          ayar: entegratorAyar,
          tip: 1
        }
        tool.api_post(this, "EFatura/EntegratorAyarlariKaydet", prm).then(responseentg => {
            if (responseentg.body == true) {
              this.text1 = "Ayarlarınız Kayıt Edildi";
              this.snackbar = true;
              this.resetWizard();
              this.$emit('callDevam');
            } else {
              this.text1 = "Hata: Ayarlarınız Kayıt Edilemedi";
              this.snackbar = true;
              this.$emit('callStop');
            }
          },
          responseentg => {
            
          }
        );
       
        var prm = {
          ayar: entegratorAyarEArsiv,
          tip: 2
        }
        tool.api_post(this, "EFatura/EntegratorAyarlariKaydet", prm).then(responseentg => {
            if (responseentg.body == true) {
              this.text1 = "Ayarlarınız Kayıt Edildi";
              this.snackbar = true;
              this.resetWizard();
              this.$emit('callDevam');
            } else {
              this.text1 = "Hata: Ayarlarınız Kayıt Edilemedi";
              this.snackbar = true;
              this.$emit('callStop');
            }
          },
          responseentg => {
            
          }
        );



      } else {
         this.text1 = this.$t(response.body.ResponseMessage);
         this.snackbar = true;
      }
    },
    (response) => {
      if (response.status === 0) {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      } else {
        this.text1 = response.statusText;
        this.snackbar = true;
      }
    }
  );




    },
    resetWizard() {
      this.currentStep = 1;
      this.entegrator = "";
      this.eArsiv = { username: "", password: "" };
      this.eFatura = { username: "", password: "" };
      this.departman = "";
      this.eInvoiceFileName = "";
      this.eArchiveFileName = "";
      this.xsltDescription = "";
    },
    closeWizard() {
      this.dialog = false;
      this.resetWizard();
    },
      open() {
        this.entgDialog = true;
      },
      close() {
        this.entgDialog = false;
      },
     
    },
  };
  
    </script>
    


    <style>
    .selected-optionv2 {
  background-color: #4A90E2 !important;
  color: white;
}

.option-cardv2 {
  transition: all 0.3s ease;
  cursor: pointer;
}

.option-cardv2:hover {
  transform: translateY(-4px);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.1);
}

    </style>